import React from 'react';
import { Control, Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import Grid from '@material-ui/core/Grid';
import TextField from 'common/components/TextField';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';
import {
  CITY,
  COMPANY, COUNSEL_PARENTS,
  PAYER_ADDRESS,
  POST_CODE,
  SCHOOL_EMAIL,
  STREET,
  STREET_NUMBER,
  TAX_ID_NUMBER
} from "../../../common/constants";
import { CheckoutValues } from 'store/ducks/checkout/types';
import ErrorPanel from 'common/components/ErrorPanel';
import { makeStyles } from '@material-ui/core/styles';

type Props = {
    checkoutValues: CheckoutValues;
    control: Control;
    errors: any;
};

const makeInputLabelClasses = makeStyles({
    shrink: {
        display: 'block',
        fontSize: '0.75rem',
        maxWidth: '90%',
        overflow: 'hidden',
        paddingLeft: '0.375rem',
        textOverflow: 'ellipsis',
        transform: 'translate(0.5rem, -0.375rem) !important',
        width: 'auto',
        whiteSpace: 'nowrap',
    },
});

const RecipientData: React.FC<Props> = ({ checkoutValues, control, errors }) => {
    const getName = (name: string) => `${PAYER_ADDRESS}.${name}`;

    const { city, company, postcode, schoolEmail, street, streetNumber, taxIdNumber } =
        checkoutValues.payerAddress || {};

    const orderType = checkoutValues.orderType;

    const InputLabelClasses = makeInputLabelClasses();

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Grid item xs={12} md={5}>
                <Controller
                    as={
                        <TextField
                            fullWidth
                            InputLabelProps={{ classes: InputLabelClasses, shrink: true }}
                        />
                    }
                    control={control}
                    defaultValue={company || ''}
                    label="* Nazwa płatnika/odbiorcy (szkoła/rada rodziców)"
                    name={getName(COMPANY)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(COMPANY)} />
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={
                        <InputMask alwaysShowMask={false} mask="9999999999">
                            {(inputProps: any) => <TextField fullWidth {...inputProps} />}
                        </InputMask>
                    }
                    control={control}
                    defaultValue={taxIdNumber || ''}
                    label={orderType === COUNSEL_PARENTS ? 'NIP' : '* NIP'}
                    name={getName(TAX_ID_NUMBER)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(TAX_ID_NUMBER)} />
            </Grid>
            <Grid item xs={12} md={4}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={street || ''}
                    label="* Ulica"
                    name={getName(STREET)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(STREET)} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={streetNumber || ''}
                    label="* Nr domu / lokalu"
                    name={getName(STREET_NUMBER)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(STREET_NUMBER)} />
            </Grid>
            <Grid item xs={12} md={3}>
                <Controller
                    as={
                        <InputMask alwaysShowMask={false} mask="99-999">
                            {(inputProps: any) => <TextField {...inputProps} fullWidth />}
                        </InputMask>
                    }
                    control={control}
                    defaultValue={postcode || ''}
                    label="* Kod pocztowy"
                    name={getName(POST_CODE)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(POST_CODE)} />
            </Grid>
            <Grid item xs={12} md={4}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={city || ''}
                    label="* Miejscowość"
                    name={getName(CITY)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(CITY)} />
            </Grid>
            <Grid item xs={12} md={5}>
                <Controller
                    as={<TextField fullWidth />}
                    control={control}
                    defaultValue={schoolEmail || ''}
                    label="* Adres e-mail szkoły"
                    name={getName(SCHOOL_EMAIL)}
                    variant="outlined"
                />
                <ErrorPanel errors={errors} name={getName(SCHOOL_EMAIL)} />
            </Grid>
        </Grid>
    );
};

export default RecipientData;
